import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './Link.module.less';
import { getUrlByTargetContent, logNative } from '../../utils/utils';
import { useDispatch } from 'react-redux';
import { setIframeVisible } from '../../actions/layout';

export default props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const handleClicks = () => {
    const { data = {}, logInfo, handleClick } = props;
    if (handleClick) {
      handleClick();
    }
    const { targetType, targetContent } = data;
    switch (targetType) {
      case '2': // 跳转外部链接
        if (data.targetUrl) {
          window.open(data.targetUrl, '_blank');
        } else if (data.targetContent) {
          if (typeof data.targetContent === 'string') {
            try {
              const targetContents = JSON.parse(targetContent) || {};
              window.open(targetContents.targetUrl);
            } catch (error) {
              logNative(`错误:${error}:${data}`);
            }
          } else if (data.targetContent.targetUrl) {
            window.open(data.targetContent.targetUrl);
          }
        }
        break;
      case '5': // 跳转外部链接
        try {
          // eslint-disable-next-line valid-typeof
          const url =
            typeof targetContent === 'string'
              ? JSON.parse(targetContent).url
              : targetContent && targetContent.url;
          // eslint-disable-next-line no-unused-expressions
          url &&
            dispatch(
              setIframeVisible({
                visible: true,
                url,
                source: logInfo && logInfo.source,
              }),
            );
        } catch (err) {
          logNative(`打开外链商品失败;${err}:${data}`);
        }
        break;
      case '10': // 跳转商店内部定义的专题详情页面（占时保留，6.5用targetType:‘11’）
        if (data.advertUrl) {
          window.open(data.advertUrl, '_blank');
        }
        break;
      default:
        // eslint-disable-next-line no-case-declarations
        const url = getUrlByTargetContent(data);
        history.push(url);
        break;
    }
  };
  return (
    <div className={styles.skip} onClick={handleClicks}>
      {props.children}
    </div>
  );
};
